module.exports = __webpack_public_path__ + "static/img/solar-energy-04.a59417b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/csr/solar-energy/solar-energy-04.jpg
// module id = mq3b
// module chunks = 100